<template>
  <div class="course-item" @click="show(course.id)">
    <div class="robin">{{course.age_start}}岁 - {{course.age_end}}岁</div>
    <div class="info">
      <p class="distance" v-if="hideLeader != true" v-html="distance"></p>
      <h3>{{course.place}}</h3>
      <p>{{course.city}}</p>
      <div class="label day">{{course.week_day}}</div>
      <div :class="`label ${course.season}`">{{season}}</div>
    </div>
    <div class="footer">
      <template v-if="hideLeader == true">
        <p>{{course.start_day|date}} - {{course.end_day|date}}</p>
        <p>{{course.start_time}} - {{course.end_time}}</p>
      </template>
      <template v-else>
        <p>{{course.start_day|date}} - {{course.end_day|date}}, {{course.start_time}} - {{course.end_time}}</p>
        <p>由{{course.leader.name}}带领</p>
      </template>
    </div>
    <!--<div class="alert" v-if="course.can_trial_enroll">首次体验特价￥{{course.trial_price}}</div>-->
    <md-icon class="arrow" name="arrow-right"/>
  </div>
</template>

<script>
import {Icon} from 'mand-mobile'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'tab-bar-demo',
  components: {
      [Icon.name]: Icon,
  },
  props:['course', 'hideLeader'],
  data() {
    return {
    }
  },
  methods: {
      show(id) {
          this.$router.push({ name: 'courses-show', params: { id: id }})
      },
  },
    filters: {
        date(day) {
            return moment(day).format("MM月DD日");
        },
    },

    computed: {
        season() {
          const season = {
              spring: "春季",
              summer: "夏季",
              fall: "秋季",
              winter: "冬季",
          };
          console.log(season[this.course.season], this.course.season);
          return this.course.season ? season[this.course.season] : '';
      },
        distance() {
            const d = this.$tools.calcDistance(this.lat, this.lng, this.course.lat, this.course.lng);
            if(d)
                return d + 'km';
            else
                return '&nbsp;';
        },
        ...mapState({
            lat: state => state.geoLocation.lat,
            lng: state => state.geoLocation.lng
        })
    },
}

</script>

<style lang="scss" scoped>
  a{text-decoration: none}
  .course-item {
    position: relative;
    background: white;
    padding: 50px 0;
    border-bottom: 1px solid #f3eee4;
    text-align: center;



    .robin {
      width: 280px;
      height: 66px;
      position: absolute;
      top: 54px;
      left: 0;
      display: flex;
      align-items: center;
      background: url("../assets/images/ribbon-label-green.svg") no-repeat;
      background-size: 100% 100%;

      font-size: 28px;
      font-weight: bold;
      color: white;
      text-transform: uppercase;
      /*margin-left: 7px;*/
      text-indent: 14px;
      line-height: 1;
    }

    .info {
      margin-top: 80px;
      h3 {
        font-size:40px;
        font-weight: 600;
        color: #414241;
        line-height: 1.4;
        margin-bottom: 6px;
      }
      p {
        font-size: 28px;
        color: #414241;
        margin-bottom: 25px;

        &.distance {
          font-weight: 600;
          font-style: italic;
          color: #8F908F;
          margin-bottom:0;
        }
      }
      .label {
        font-size: 28px;
        font-weight: bold;
        letter-spacing: 10px;
        text-align: center;
        color: white;
        width: 276px;
        margin: 0 auto 12px;
        height: 46px;
        line-height: 46px;
        /*display: inline-block;*/
        background: #547625;

        &.day {
          background: #4A9896;
        }

        &.spring {background: #547625}
        &.summer {background: #D2AC5F}
        &.fall {background: #414241}
        &.winter {background: #377270}
      }
    }

    .footer {
      margin-top: 40px;
      font-size: 28px;
      line-height: 1.4;
      color: #414241;
    }

    .arrow {
      position: absolute;
      right: 20px;
      top: 50%;
      width: 54px;
      height: 54px;
      margin-top: -27px;
      font-size: 54px;
      font-weight:bold;
      color: #f26522;
    }

    .alert {
      height: 40px;
      line-height: 40px;
      background: #f26522;
      color: white;
      font-weight: bold;
      text-align: center;
      font-size: 24px;
      margin-top:20px;
    }
  }
</style>

